import { render, staticRenderFns } from "./jadwal_donor.vue?vue&type=template&id=051a3d23"
import script from "./jadwal_donor.vue?vue&type=script&lang=js"
export * from "./jadwal_donor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QIcon,QBadge,QPagination,QDialog,QFile,QCardActions,QSelect,QImg,QSeparator,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QTooltip,QIcon,QBadge,QPagination,QDialog,QFile,QCardActions,QSelect,QImg,QSeparator})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
